<template>
  <div class="procedure-introduction">
    <div class="step-3">
      <div class="title">
        {{ $t('courses.procedureTitle') }}
      </div>
      <div class="step-wrapper">
        <dl v-for="(step,index) in procedureStep" :key="index" class="step">
          <dd :class="[step.cls]" class="step-img" />
          <dt>
            <p class="step-num">
              {{ $t('courses.step', {index: index+1}) }}
            </p>
            <p class="step-title">
              {{ step.title }}
            </p>
            <p class="step-des" v-html="step.des" />
          </dt>
        </dl>
      </div>
      <p v-if="locale=='sg'" class="tips">
        {{ $t('courses.FAQsTips') }}
        <nuxt-link to="/faq" class="faq" style="text-decoration: underline;">
          FAQs<span class="dot">.</span>
        </nuxt-link>
      </p>
    </div>
  </div>
</template>
<script>

export default {
  props: {
    courseDetail: {
      default: () => ({}),
      type: Object,
    },
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    procedureStep() {
      const courseType = this.courseDetail.spec.courseType || null
      if (this.locale === 'hk' && [2, 3, 5].indexOf(courseType) >= 0) return this.$t('courses.procedureStep2')
      return this.$t('courses.procedureStep')
    },
  },
}
</script>
<style lang="scss" scoped>
.procedure-introduction {
  .tips {
    color: var(--txt-color-lv2);
    margin-top: 20px;
    padding-left: 64px;
    font-size: 16px;

    .faq {
      color: var(--txt-color-link);
      font-weight: normal;
    }

    .dot {
      color: var(--txt-color-lv2);
    }
  }

  .producer-img {
    padding: 8px 8px 0;

    .add-image {
      height: 209px;
      background-image: url('~assets/images/courses/courses-step.jpg');
      background-size: cover;
    }

    .imgSg {
      background-image: url('~assets/images/courses/new-courses-step.jpg');
    }
  }

  .step-3 {
    padding-top: 40px;
    // background: #f4f6fa;

    .title {
      font-weight: bold;
      font-size: 32px;
      line-height: 33px;
      margin-bottom: 21px;
      color: var(--txt-color-lv1);
    }

    .step {
      display: flex;
      margin-bottom: 24px;

      .step-img {
        min-width: 55px;
        height: 55px;
        margin-right: 10px;

        &.desktop-outline {
          background-image: url("~assets/images/courses/step1-desktop-outline.png");
          background-size: cover;
        }

        &.access-course-details {
          background-image: url("~assets/images/courses/step2-access-course-details.png");
          background-size: cover;
        }

        &.attend-the-class {
          background-image: url("~assets/images/courses/step3-attend-the-class.png");
          background-size: cover;
        }
      }

      .step-num {
        color: var(--txt-color-link);
        font-size: 24px;
        font-weight: 600;
        line-height: 29px;
      }

      .step-title {
        color: var(--txt-color-lv3);
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 600;
        line-height: 29px;
      }

      .step-des {
        color: var(--txt-color-lv1);
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;

        /deep/a {
          color: var(--txt-color-link) !important;
        }
      }
    }
  }
}
</style>
